import { render, staticRenderFns } from "./StudentCombo.vue?vue&type=template&id=7f27c9fb&scoped=true"
import script from "./StudentCombo.vue?vue&type=script&lang=js"
export * from "./StudentCombo.vue?vue&type=script&lang=js"
import style0 from "./StudentCombo.vue?vue&type=style&index=0&id=7f27c9fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f27c9fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VListItemContent,VListItemSubtitle,VListItemTitle})
